export default __webpack_public_path__ + "assets/img_webp/ja-logo.6c72a06c.png";